import role from '@/auth/role'

export default [
  {
    path: '/admin/users',
    name: 'admin-users',
    component: () => import('@/views/admin/users/AdminUsers.vue'),
    meta: {
      title: 'admin.users.pageTitle',
      pageTitle: 'admin.users.pageTitle',
      breadcrumb: [
        {
          text: 'navigation.administration',
        },
        {
          text: 'admin.users.breadcrumb',
          active: true,
        },
      ],
      access: [role.superAdmin],
    },
  },
]
